export * from './Page_EHREmulator.js';
//# sourceMappingURL=index.js.map